<template>
	<div
		:class="[
			'horizontal-search',
			{ 'horizontal-search--block': blockElem },
		]"
	>
		<form
			id="horizontal-search-form"
			class="horizontal-search__filter-side"
			@submit.prevent="$emit('search')"
		>
			<slot class="slot-test" />
		</form>
		<div class="horizontal-search__button-side">
			<button
				form="horizontal-search-form"
				type="submit"
				class="btn-main blue horizontal-search__button"
				v-text="'검색'"
			/>
			<button
				v-if="useInitButton"
				type="button"
				class="btn-main horizontal-search__button"
				v-text="'초기화'"
				@click="$emit('init')"
			/>
			<slot
				name="optionalButton"
				className="horizontal-search__button horizontal-search__button--optional"
			/>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'HorizontalSearch',
		props: {
			blockElem: {
				type: Boolean,
				default: false,
			},
			useInitButton: {
				type: Boolean,
				default: true,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.horizontal-search {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.horizontal-search__filter-side,
		.horizontal-search__button-side {
			display: flex;
		}

		.horizontal-search__filter-side > * {
			margin: 4px;
		}

		.horizontal-search__button {
			height: 36px;
			margin-left: 16px;
			border-radius: 0;
			line-height: 34px;
		}
	}

	.horizontal-search--block {
		display: block;
		width: 100%;
		background-color: #f4f7fa;
		padding: 4px;

		&:after {
			content: '';
			display: block;
			clear: both;
		}

		.horizontal-search__filter-side {
			max-width: 100%;
			flex-shrink: 0;
			flex-wrap: wrap;
			float: left;
		}

		.horizontal-search__button-side {
			float: right;
			margin: 4px;
		}

		.horizontal-search__button {
			margin-left: 0;
		}
	}

	.horizontal-search {
		&__button--optional {
			margin-left: 20px !important;
		}
	}
</style>
